import {
    inventoryCertifiedTileClick as reaxlInventoryCertifiedTileClick,
    inventoryClick as reaxlInventoryClick,
    inventoryExploreAllSpecialsClick as reaxlInventoryExploreAllSpecialsClick,
    inventoryGetNotifiedClick as reaxlInventoryGetNotifiedClick,
    inventoryHowPriceChangedClick as reaxlInventoryHowPriceChangedClick,
    inventoryMediaViewerClick as reaxlInventoryMediaViewerClick,
    inventoryProductClick as reaxlInventoryProductClick,
    inventoryProductImpressions as reaxlInventoryProductImpressions,
    inventorySeeHowPriceComparesClick as reaxlInventorySeeHowPriceComparesClick,
    inventoryVideoCompleted as reaxlInventoryVideoCompleted,
    inventoryVideoMilestones as reaxlInventoryVideoMilestones,
    inventoryVideoPlay as reaxlInventoryVideoPlay,
    mediaGalleryNdsCTAClick as reaxlMediaGalleryNdsCTAClick,
    mediaSliderMediaClick as reaxlMediaSliderMediaClick,
    mediaSliderVhrClick as reaxlMediaSliderVhrClick,
    mediaSliderVhrImpression as reaxlMediaSliderVhrImpression,
    mediaTabClick as reaxlMediaTabClick,
    mediaVideoPhotoClick as reaxlMediaVideoPhotoClick,
    mediaViewerPagination as reaxlMediaViewerPagination,
    shareClick as reaxlShareClick,
    viewAllMediaClick as reaxlViewAllMediaClick,
} from 'reaxl-analytics-handlers';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import {
    compareAddListingClick as reaxlCompareAddListingClick,
    compareListingsDrawerClick as reaxlCompareListingsDrawerClick,
} from './compareListingAnalyticsHandlers';
import { inventoryVehicleConditionHighlightsClick as vdpInventoryVehicleConditionHighlightsClick } from './vdp/inventoryVehicleDetailsEvents';
import { snap360Click as reaxlSnap360Click, vi360Click as reaxlVi360Click } from './vdp/snap360AnalyticHandlers';

export const inventoryCertifiedTileClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);

    return reaxlInventoryCertifiedTileClick({
        ...metadata,
        data: {
            ...data,
            inventoryId: activeInventory.id,
            eventSource: 'vehicle',
        },
    }, option);
};

export const inventoryClick = (metadata, option) => {
    const { data, state } = metadata;
    const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);

    return reaxlInventoryClick({
        ...metadata,
        data: {
            ...data,
            eventSource: 'vehicle',
            pixallData: {
                ...data.pixallData,
                filterValues,
            },
        },
    }, option);
};

export const inventoryProductClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryProductClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const compareListingsDrawerClick = (metadata, option) => {
    const { data, state } = metadata;
    const { pixallData } = data;
    const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);

    return reaxlCompareListingsDrawerClick({
        ...metadata,
        pixallData: {
            ...pixallData,
            filterValues,
        },
    }, option);
};

export const compareAddListingClick = (metadata, option) => {
    const { data, state } = metadata;
    const { pixallData } = data;
    const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);

    return reaxlCompareAddListingClick({
        ...metadata,
        pixallData: {
            ...pixallData,
            filterValues,
        },
    }, option);
};

export const inventoryProductImpressions = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryProductImpressions({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryMediaViewerClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryMediaViewerClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const viewAllMediaClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlViewAllMediaClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const mediaViewerPagination = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlMediaViewerPagination({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const mediaTabClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlMediaTabClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const mediaVideoPhotoClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlMediaVideoPhotoClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryVehicleConditionHighlightsClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    const filterValues = srpFiltersDuck.selectors.getFiltersValues(state);
    return vdpInventoryVehicleConditionHighlightsClick({
        ...metadata,
        data: {
            filterValues,
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryVideoPlay = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryVideoPlay({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryVideoCompleted = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryVideoCompleted({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryVideoMilestones = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryVideoMilestones({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const mediaGalleryNdsCTAClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlMediaGalleryNdsCTAClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const shareClick = (metadata, option) => {
    // TODO on SRP GA is missing CD's 100 - 160
    const { data } = metadata;
    return reaxlShareClick({
        ...metadata,
        data: {
            ...data,
            inventoryId: data?.id,
        },
    }, option);
};

export const vi360Click = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlVi360Click({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const snap360Click = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlSnap360Click({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const mediaSliderMediaClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlMediaSliderMediaClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const mediaSliderVhrClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlMediaSliderVhrClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const mediaSliderVhrImpression = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlMediaSliderVhrImpression({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryExploreAllSpecialsClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryExploreAllSpecialsClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventorySeeHowPriceComparesClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventorySeeHowPriceComparesClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryHowPriceChangedClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryHowPriceChangedClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};

export const inventoryGetNotifiedClick = (metadata, option) => {
    const { data, state } = metadata;
    const activeInventory = vdpResultsDuck.selectors.getVdpActiveInventory(state);
    return reaxlInventoryGetNotifiedClick({
        ...metadata,
        data: {
            inventoryId: activeInventory?.id,
            ...data,
        },
    }, option);
};
